import { createContext } from 'react'

const ScrollContext = createContext({
  scrollProps: {},
  scrollTo: () => {},
  eventEmitter: {},
})

export default ScrollContext
